module.exports = __webpack_public_path__ + "img/jiandingbao.d88db38e.jpg";